import SetPaymentRequestModelBase from '../_generated/modelBases/set-payment-request-model-base';

export default class SetPaymentRequestModel extends SetPaymentRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
